import { handlePaginatedData } from '../services/DataHelperFunctions';
import { EAction, EActivity, EApiType, EUrlParams } from '../data/Constants';
import AxiosClient from './AxiosClient';
import { handleSuccess, handleApiErrorWithFallback, handleError } from './HttpUtil';
import type { Dispatch } from '@reduxjs/toolkit';

export const ProductHierarchyApi = {
  importProductHierarchy: (action: { request }, dispatch: Dispatch) => {
    return AxiosClient.post('/product/v1/hierarchy/create/file', { file: action.request })
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err);
      });
  },

  getProductHierarchy: (
    action: { page: number; limit: number; searchCode?: string },
    dispatch: Dispatch
  ) => {
    const requestBody = action.searchCode ? action.searchCode : '';
    return AxiosClient.post(
      `/product/v1/hierarchy/read?${EUrlParams.Page}=${action.page}&${EUrlParams.Limit}=${action.limit}`,
      { search: requestBody }
    )
      .then((response) => {
        return handlePaginatedData(response, action);
      })
      .catch((err) => {
        return handleApiErrorWithFallback(
          dispatch,
          err,
          { page: action.page, searchKey: action.searchCode },
          EAction.Read,
          EApiType.ProductHierarchyKey
        );
      });
  },

  compareProductHierarchy: (
    action: { page: number; limit: number; searchCode?: string },
    dispatch: Dispatch
  ) => {
    const requestBody = action.searchCode ? action.searchCode : '';
    const queryParams =
      `${EUrlParams.Page}=` + action.page + `&${EUrlParams.Limit}=` + action.limit;
    return AxiosClient.post(`/product/v1/hierarchy/compare?${queryParams}`, { search: requestBody })
      .then((response) => {
        return handlePaginatedData(response, action);
      })
      .catch((err) => {
        return handleApiErrorWithFallback(
          dispatch,
          err,
          { page: action.page, searchKey: action.searchCode },
          EAction.Read,
          EApiType.CompareProductHierarchyKey
        );
      });
  },

  publishProductHierarchy: (action: { activity: EActivity }, dispatch: Dispatch) => {
    return AxiosClient.post('/product/v1/hierarchy/publish', { activity: action.activity })
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err);
      });
  },
};
